import { render, staticRenderFns } from "./newRole.vue?vue&type=template&id=b202f3e2&scoped=true"
import script from "./newRole.vue?vue&type=script&lang=js"
export * from "./newRole.vue?vue&type=script&lang=js"
import style0 from "./newRole.vue?vue&type=style&index=0&id=b202f3e2&prod&lang=css"
import style1 from "./newRole.vue?vue&type=style&index=1&id=b202f3e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b202f3e2",
  null
  
)

export default component.exports